import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { MODAL_WIDTH, MODAL_WIDTH_SIZES } from './utils/constants';
var styles = {
  modalContainer: {
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'grey.0',
    fontSize: 1,
    color: 'grey.10',
    borderRadius: 'var(--corners-pageframe)'
  }
};
var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children,
    width = _ref.width,
    className = _ref.className;
  var getWidthAndHeight = function getWidthAndHeight() {
    var modalWidth = MODAL_WIDTH[width] ? MODAL_WIDTH[width] : "".concat(width, "px");
    return {
      width: modalWidth
    };
  };
  return jsx("div", {
    className: className,
    sx: _objectSpread(_objectSpread({}, styles.modalContainer), getWidthAndHeight())
  }, children);
};
ModalContainer.defaultProps = {
  width: MODAL_WIDTH_SIZES.LARGE
};
export { ModalContainer };